<ng-container *ngIf="this.solution?.liveError">
  <p>Purtroppo, questa soluzione non è più disponibile</p>
</ng-container>

<ng-container *ngIf="this.solution?.isLoadingLiveInfo">
  <div class="d-flex">
    <span class="me-2">
      Stiamo Caricando i dettagli della soluzione
    </span>

    <div class="solution__loader is-loading">
      <div class="solution__loader__circle u-price-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!this.solution?.liveError && !this.solution?.isLoadingLiveInfo">

  <div class="flight" *ngIf="solution?.journey?.outward">
    <div class="flight__type">
      <h4 class="flight__type__title">andata</h4>
      <span class="flight__type__airport-name">{{solution.journey.outward.departureAirport?.name}}
        ({{solution.journey.outward.departureAirport?.code}})</span>
      <span class="flight__type__airport-name"
            *ngIf="solution.journey.outward.stopOver">
                {{solution.journey.outward.stopOver.name}}
        <span *ngIf="((solution.journey.outward.stopOver.id | getDataFromMapping:'airportId') | async)?.Code">
                  ({{((solution.journey.outward.stopOver.id | getDataFromMapping:'airportId') | async)?.Code}})
                </span>
              </span>
      <span class="flight__type__airport-name">{{solution.journey.outward.arrivalAirport?.name}}
        ({{solution.journey.outward.arrivalAirport?.code}})</span>
    </div>
    <div class="flight__steps" [ngClass]="{'flight__steps--outward' : solution.journey.outward.stopOver}">
      <div class="flight__step flight__step--from">
        <span class="flight__step__label">Partenza</span>
        <h4 class="flight__step__time">{{solution.journey.outward.departureHour}}</h4>
        <span class="flight__step__date">{{solution.journey.outward.departureDate | formatDate :
          'extendedDateDayMonth'}}</span>
        <h4 class="flight__step__apt-code">{{solution.journey.outward.departureAirport?.code}}</h4>
      </div>
      <div class="flight__separator">
        <span class="flight__separator__bar"></span>
      </div>
      <div class="flight__step flight__step--to flight__step--outward" *ngIf="solution.journey.outward.stopOver">
        <span class="flight__step__label">Scalo</span>
        <small class="flight__step__time--outward" *ngIf="solution.journey.outward.stopOverDuration">
          {{solution.journey.outward.stopOverDuration}}
        </small>
        <h4 class="flight__step__apt-code">
          {{((solution.journey.outward.stopOver.id | getDataFromMapping:'airportId') | async)?.Code}}
        </h4>
      </div>
      <div class="flight__separator" *ngIf="solution.journey.outward.stopOver">
        <span class="flight__separator__bar"></span>
      </div>
      <div class="flight__step flight__step--to">
        <span class="flight__step__label">Arrivo</span>
        <h4 class="flight__step__time">{{solution.journey.outward.arrivalHour}}</h4>
        <span class="flight__step__date align-self-end">{{solution.journey.outward.arrivalDate | formatDate :
          'extendedDateDayMonth'}}</span>
        <h4 class="flight__step__apt-code">{{solution.journey.outward.arrivalAirport?.code}}</h4>
      </div>
    </div>
  </div>

  <div class="flight" *ngIf="solution?.journey?.return">
    <div class="flight__type">
      <h4 class="flight__type__title">ritorno</h4>
      <span class="flight__type__airport-name">{{solution.journey.return.departureAirport?.name}}
        ({{solution.journey.return.departureAirport?.code}})</span>
      <span class="flight__type__airport-name"
            *ngIf="solution.journey.return.stopOver">
                {{solution.journey.return.stopOver.name}}
        <span *ngIf="((solution.journey.return.stopOver.id | getDataFromMapping:'airportId') | async)?.Code">
                  ({{((solution.journey.return.stopOver.id | getDataFromMapping:'airportId') | async)?.Code}})
                </span>
              </span>
      <span class="flight__type__airport-name">{{solution.journey.return.arrivalAirport?.name}}
        ({{solution.journey.return.arrivalAirport?.code}})</span>
    </div>
    <div class="flight__steps" [ngClass]="{'flight__steps--outward' : solution.journey.outward.stopOver}">
      <div class="flight__step flight__step--from">
        <span class="flight__step__label">Partenza</span>
        <h4 class="flight__step__time">{{solution.journey.return.departureHour}}</h4>
        <span class="flight__step__date">{{solution.journey.return.departureDate | formatDate :
          'extendedDateDayMonth'}}</span>
        <h4 class="flight__step__apt-code">{{solution.journey.return.departureAirport?.code}}</h4>
      </div>
      <div class="flight__separator">
        <span class="flight__separator__bar"></span>
      </div>
      <div class="flight__step flight__step--to flight__step--outward" *ngIf="solution.journey.return.stopOver">
        <span class="flight__step__label">Scalo</span>
        <small class="flight__step__time--outward" *ngIf="solution.journey.return.stopOverDuration">
          {{solution.journey.return.stopOverDuration}}
        </small>
        <h4 class="flight__step__apt-code"
            *ngIf="((solution.journey.return.stopOver.id | getDataFromMapping:'airportId') | async)?.Code">
          {{((solution.journey.return.stopOver.id | getDataFromMapping:'airportId') | async)?.Code}}
        </h4>
      </div>
      <div class="flight__separator" *ngIf="solution.journey.return.stopOver">
        <span class="flight__separator__bar"></span>
      </div>
      <div class="flight__step flight__step--to">
        <span class="flight__step__label">Arrivo</span>
        <h4 class="flight__step__time">{{solution.journey.return.arrivalHour}}</h4>
        <span class="flight__step__date align-self-end">{{solution.journey.return.arrivalDate | formatDate :
          'extendedDateDayMonth'}}</span>
        <h4 class="flight__step__apt-code">{{solution.journey.return.arrivalAirport?.code}}</h4>
      </div>
    </div>
  </div>



</ng-container>
